import { Alert, Button, Layout, PageHeader, Typography } from 'antd'
import styled from 'styled-components'

const { Footer, Content } = Layout

export const FormLayout = styled(Layout)`
	display: flex;
	flex-flow: column;
	width: 100%;
	height: 100%;
	align-items: center;
	overflow: hidden;
`

export const FormHeader = styled(PageHeader)`
	border-bottom: 1px solid rgb(217, 217, 217);
	background-color: white;
	padding: 10px 30px;
	flex: 0 1 68px;
	width: 100%;
`

export const FormButton = styled(Button)`
	width: 108px;
	height: 36px;
	line-height: 1px;
	border-width: 2px;
	font-weight: 500;
`
export const FormContent = styled(Content)`
	width: 100%;
	background-color: transparent;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: stretch;
`

export const FormFooter = styled(Footer)`
	background-color: white;
	padding: 10px;
	border-top: 1px solid rgb(217, 217, 217);
	order: 2;
	width: 100%;
	display: flex;
	justify-content: center;
	column-gap: 12px;

	* {
		margin: 0;
	}
`

export const FormPagination = styled(Typography)`
	width: 107px;
	display: flex;
	justify-content: center;
	align-items: center;
`

export const SuggestionAlert = styled(Alert)`
	.ant-alert-message {
		font-weight: 500;
	}

	margin-top: 16px;
`

export const scrollbarStyle = `
* {
	scrollbar-width: thin;
}

*::-webkit-scrollbar {
	width: 14px;
}

*::-webkit-scrollbar-track {
	background: #f0f0f0;
}

*::-webkit-scrollbar-thumb {
	background: #cecece;
}

*::-webkit-scrollbar-thumb:hover {
	background: #a6a6a6;
}

*::-webkit-scrollbar-button:single-button {
	background: no-repeat #f0f0f0;
	background-size: 9.5px;
	height: 15px;
}

*::-webkit-scrollbar-button:single-button:vertical:decrement {
	background-position: center 4px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5' fill='none'%3E%3Cpath d='M4.35355 0.646473C4.15829 0.451211 3.84171 0.45121 3.64645 0.646473L0.464466 3.82845C0.269204 4.02372 0.269204 4.3403 0.464466 4.53556C0.659728 4.73082 0.976311 4.73082 1.17157 4.53556L4 1.70713L6.82843 4.53556C7.02369 4.73082 7.34027 4.73082 7.53553 4.53556C7.7308 4.3403 7.7308 4.02372 7.53553 3.82845L4.35355 0.646473ZM4.5 1.94434L4.5 1.00003L3.5 1.00003L3.5 1.94434L4.5 1.94434Z' fill='black'/%3E%3C/svg%3E");
}

*::-webkit-scrollbar-button:single-button:vertical:increment {
	background-position: center 5px;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5' fill='none'%3E%3Cpath d='M3.64645 4.29786C3.84171 4.49313 4.15829 4.49313 4.35355 4.29786L7.53553 1.11588C7.7308 0.920621 7.7308 0.604038 7.53553 0.408776C7.34027 0.213514 7.02369 0.213514 6.82843 0.408776L4 3.2372L1.17157 0.408776C0.976311 0.213514 0.659728 0.213514 0.464466 0.408776C0.269204 0.604038 0.269204 0.920621 0.464466 1.11588L3.64645 4.29786ZM3.5 3L3.5 3.94431L4.5 3.94431L4.5 3L3.5 3Z' fill='black'/%3E%3C/svg%3E");
}

*::-webkit-scrollbar-button:vertical:start:increment,
*::-webkit-scrollbar-button:vertical:end:decrement {
	display: none;
}
`

export const FormContentContainer = styled.div`
	display: ${(props) => (props.isHidden ? 'none' : 'flex')};
	flex-direction: column;
	align-items: center;
	gap: 16px;
	background-color: white;
	max-width: ${(props) => (props?.isPreview ? '820px' : '640px')};
	overflow: ${(props) => (props?.isPreview ? 'auto' : 'scroll')};
	margin: 10px;
	margin-top: ${(props) => (props?.isPreview ? '72px' : '10px')};
	width: 100%;
	border: 1px solid rgb(217, 217, 217);

	@media (max-width: 600px) {
		margin: 0;
		border: 0;
	}

	${scrollbarStyle}
`
